import script from "./GetRandomMenuBtn.vue?vue&type=script&setup=true&lang=ts"
export * from "./GetRandomMenuBtn.vue?vue&type=script&setup=true&lang=ts"

import "./GetRandomMenuBtn.vue?vue&type=style&index=0&id=36218f40&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36218f40"]])

export default __exports__